import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ProfileDropdown } from '@components/_global/Header/Profile/ProfileDropdown/ProfileDropdown';
import { MakeActionSelect } from '@components/molecules/MakeActionSelect/MakeActionSelect';
import { NavLinks } from '@components/molecules/NavLinks/NavLinks';
import { Notifications } from '@components/organisms/Notifications/Notifications';

import { UnreadNotificationCountDocument } from '@graphql/generated/graphql';

import { useQuery, useReactiveVar } from '@apollo/client';
import { authVar } from '@boot/reactiveVariables';

import {
    Divider,
    GuestMode,
    GuestModeText,
    IconButton,
    IconWrapper,
    MenuActions,
    MenuIcon,
    MenuWrapper,
    NotificationsDot,
} from './DesktopMenu.styled';

export const DesktopMenu = () => {
    const { t } = useTranslation();
    const [isNotificationsOpen, setIsNotificationsOpen] = useState(false);
    const [isProfileOpen, setIsProfileOpen] = useState(false);

    const isGuest = useReactiveVar(authVar).isGuest;

    const { data: notificationCount } = useQuery(
        UnreadNotificationCountDocument,
        { notifyOnNetworkStatusChange: true, skip: isGuest },
    );

    return (
        <MenuWrapper>
            <NavLinks />
            <MenuActions>
                <Divider />
                <MakeActionSelect />
                <Divider />
                {isGuest ? (
                    <GuestMode>
                        <GuestModeText>{t('GUEST_MODE_TEXT')}</GuestModeText>
                    </GuestMode>
                ) : (
                    <>
                        <IconWrapper>
                            <IconButton
                                isOpen={isNotificationsOpen}
                                onClick={() => setIsNotificationsOpen(true)}
                            >
                                <MenuIcon
                                    icon={'SvgNotification24'}
                                    size={24}
                                />
                                {!!notificationCount?.amount && (
                                    <NotificationsDot />
                                )}
                            </IconButton>
                            {isNotificationsOpen && (
                                <Notifications
                                    onClose={() =>
                                        setIsNotificationsOpen(false)
                                    }
                                />
                            )}
                        </IconWrapper>
                        <Divider />
                    </>
                )}
                <IconWrapper>
                    <IconButton
                        isOpen={isProfileOpen}
                        onClick={() => setIsProfileOpen(true)}
                    >
                        <MenuIcon icon={'SvgProfile24'} size={24} />
                    </IconButton>

                    {isProfileOpen && (
                        <ProfileDropdown setIsOpen={setIsProfileOpen} />
                    )}
                </IconWrapper>
            </MenuActions>
        </MenuWrapper>
    );
};
